import React from 'react';
import PropTypes from 'prop-types';
import ExtButton from './extButton';
import Conversations from './conversations';


const StartConversation = ({
  backgroundColor }) => (
    <div className="msgrightw">
      <ExtButton />
      <Conversations backgroundColor={backgroundColor} />
    </div>
);

StartConversation.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
};

export default StartConversation;



// WEBPACK FOOTER //
// ./src/views/modules/messages/startConversation/StartConversation.jsx